import { Stack, styled } from '@mui/material'
import { isNotNullOrUndefined, RoundImage, tokens } from 'ComponentLibrary'

export type AssetCardProps = {
    imageSrc?: string
    imageFallbackSrc?: string
    children: React.ReactNode
    imageHeight?: string
    imageWidth?: string
    placeHolderImage?: string
    imageAltText?: string
    placeHolderImageAltText?: string
    objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down'
}

const ASSET_PLACEHOLDER_IMAGE = '/asset-placeholder.svg'
const ASSET_PLACEHOLDER_IMAGE_ALT = 'Placeholder image showing a house'
const ASSET_IMAGE_ALT = 'Image showing the asset'
const HEIGHT = '59' //'76'
const WIDTH = '76' //'97'

export default function ListCard({
    imageSrc,
    imageFallbackSrc,
    imageHeight = HEIGHT,
    imageWidth = WIDTH,
    children,
    placeHolderImage = ASSET_PLACEHOLDER_IMAGE,
    imageAltText = ASSET_IMAGE_ALT,
    placeHolderImageAltText = ASSET_PLACEHOLDER_IMAGE_ALT,
    objectFit = 'cover',
}: AssetCardProps) {
    return (
        <Card>
            <ImageWrapper>
                <RoundImage
                    src={imageSrc}
                    alt={imageAltText || placeHolderImageAltText}
                    width={imageWidth}
                    height={imageHeight}
                    objectFit={objectFit}
                    loading="lazy"
                    fallbackImageSrc={[imageFallbackSrc, placeHolderImage].filter(isNotNullOrUndefined)}
                />
            </ImageWrapper>
            <Stack
                direction="row"
                width="100%"
                height="100%"
                justifyContent="space-between"
                alignItems="center"
                gap={tokens.SizingSpacing200}
            >
                {children}
            </Stack>
        </Card>
    )
}

const Card = styled('div')`
    display: flex;
    position: relative;
    flex-direction: row;
    height: ${HEIGHT}px;
    width: 100%;
    align-items: center;
    gap: ${tokens.SizingSpacing200};
`

export const ListCardInfo = styled(Stack)`
    width: 291px;
    justify-content: center;
`

const ImageWrapper = styled('div')`
    height: ${HEIGHT}px;
    min-width: ${WIDTH}px;
`

export const AssetList = styled('ul')(() => ({
    listStyle: 'none',
    gap: tokens.SizingSpacing150,
    display: 'grid',
    padding: 0,
    margin: 0,
}))

export const ListItem = styled('li')(() => ({
    width: '100%',
    height: '100%',
    borderRadius: tokens.SizingCornerM,
    border: `${tokens.SizingBorderS} solid ${tokens.ColorBorderDefault}`,
    padding: tokens.SizingSpacing150,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:hover, &:focus': {
        cursor: 'pointer',
        backgroundColor: tokens.ColorSurfaceHover,
    },
    '&:active': {
        backgroundColor: tokens.ColorSurfacePressed,
    },
    '& a': {
        textDecoration: 'none',
    },
}))
